/*
 * Code generated by maegi. DO NOT EDIT.
 */

import type React from "react";

export const Share32 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={32} height={32} viewBox="0 0 32 32" {...props}>
    <g fill="none" fillRule="evenodd">
      <path stroke="currentColor" strokeLinecap="square" strokeWidth={2} d="m21 10-10 6 10 6" />
      <circle cx={21} cy={10} r={3} fill="currentColor" />
      <circle cx={21} cy={22} r={3} fill="currentColor" />
      <circle cx={11} cy={16} r={3} fill="currentColor" />
    </g>
  </svg>
);

export const __descriptor_Share = {
  name: "Share",
  instances: [{ size: 32, Component: Share32 }],
} as const;
